import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ParaisoFiscal = {

    async Get() {  return await methods.Get("ParaisoFiscal/Get" ); },
    async Post(data) { return await methods.Post("ParaisoFiscal/Post", data) },
    async Put(qs, data) { return await methods.Put("ParaisoFiscal/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ParaisoFiscal/Delete" + useParamsJson(qs)) }
};

export default ParaisoFiscal;